import { Building2, MapPin, Compass, Layers, Sun, Leaf, Trees, Bus } from "lucide-react";
import { QUICK_HIGHLIGHTS, IMAGES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = { Building2, MapPin, Compass, Layers, Sun, Leaf, Trees, Bus };

export const Highlights = () => (
  <section id="highlights" data-testid="highlights-section" className="py-20 sm:py-28 bg-[#FFFFFF]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-end mb-14">
        <div className="lg:col-span-7">
          <SectionHeading index="01" eyebrow="The Vision" title="About Vinayak 21 Acres" />
          <Reveal delay={0.1}>
            <p className="mt-4 font-sub font-semibold text-[#65A30D] text-xs sm:text-sm tracking-[0.14em] uppercase">
              A greener way to live beside New Town
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-4 text-[#4D7C0F] text-base sm:text-lg leading-relaxed max-w-2xl">
              Vinayak 21 Acres is a residential development at Hatishala, off and adjacent to Newtown Action Area
              III, Kolkata, offering thoughtfully planned 2 &amp; 3 BHK residences. The project is designed around
              the things that quietly make a home better — natural light, cross ventilation, efficient floor plans
              and practical everyday living. Double-height sky terraces open each residence to the sky, while green
              infrastructure and nature-oriented planning shape a calmer rhythm of life.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="img-frame rounded-sm overflow-hidden">
            <div className="overflow-hidden rounded-sm">
              <img src={IMAGES.tower} alt="Modern residential tower elevation near Newtown Action Area III Kolkata" className="w-full h-64 object-cover" loading="lazy" />
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal>
        <h2 className="font-serif-display text-2xl sm:text-3xl text-[#365314] mb-8" data-testid="highlights-subheading">Vinayak 21 Acres Project Highlights</h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {QUICK_HIGHLIGHTS.map((h, i) => {
          const Icon = ICONS[h.icon] || Building2;
          return (
            <Reveal key={h.title} delay={0.06 * i}>
              <div
                data-testid={`highlight-card-${i}`}
                className="group bg-white border border-[#DCECC0] rounded-xl p-6 h-full hover:border-[#84CC16] hover:shadow-[0_20px_40px_-18px_rgba(77,124,15,0.18)] hover:-translate-y-1 transition-all duration-500"
              >
                <div className="w-11 h-11 rounded-full bg-[#EAF5D6] border border-[#84CC16]/30 flex items-center justify-center text-[#365314] group-hover:bg-[#84CC16] group-hover:text-[#365314] transition-all duration-500">
                  <Icon size={19} strokeWidth={1.6} />
                </div>
                <h3 className="font-serif-display text-xl font-medium text-[#365314] mt-5 leading-snug">{h.title}</h3>
                <p className="text-sm text-[#65A30D] mt-2 leading-relaxed">{h.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
